import {
  DropzoneReadonly,
  FiFileText,
  Flex,
  Grid,
  GridItem,
  ReadOnlyField,
  useFormContext,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import {
  formatDateToShortFormat,
  unixTimestampToDate,
} from '@bcba/common-utils';
import { downloadDocument } from '../../../../utils/downloadDocument.utils';

interface Props {
  fieldPrefix: string;
  label: string;
}

export const EquityInfoDocument = ({ fieldPrefix, label }: Props) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const expirationDateValue = watch(`${fieldPrefix}.expirationDate`);
  const uuidKey = `${fieldPrefix}.uuid`;

  return (
    <Flex direction="column" gap={6}>
      <Flex direction="column">
        <DropzoneReadonly
          fileName={watch(`${fieldPrefix}.originalName`)}
          label={label}
          onClick={() => downloadDocument(watch(uuidKey))}
          leftIcon={FiFileText}
        />
      </Flex>
      <Grid
        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
        gap={6}
      >
        <GridItem>
          <ReadOnlyField
            label={t('common.documentId.label')}
            value={
              watch(`${fieldPrefix}.bcIdentifier`)
                ? watch(`${fieldPrefix}.bcIdentifier`)
                : t('common.toBeCompletedByBolsa')
            }
          />
        </GridItem>
        <GridItem>
          <ReadOnlyField
            label={t('common.expirationDate.label')}
            value={
              expirationDateValue
                ? formatDateToShortFormat(
                    unixTimestampToDate(expirationDateValue),
                  )
                : t('common.toBeCompletedByBolsa')
            }
          />
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default EquityInfoDocument;
